<template>
    <div class="magnifier">
        <div class="magnifier-inner">
            <div data-title="大图" class="small-box" @mouseover="handOver" @mousemove="handMove" @mouseout="handOut">
                <img class="smallPic" :src="`${src}?x-oss-process=image/resize,l_836`" />
                <div
                    data-title="大图放大遮罩"
                    class="magnifier-zoom"
                    v-show="showMask"
                    :style="{
                        background: configs.maskColor,
                        height: configs.maskWidth + 'px',
                        width: configs.maskHeight + 'px',
                        opacity: configs.maskOpacity,
                        transform: transformMask,
                    }"
                    v-if="!vuex_h5"
                ></div>
            </div>

            <div
                data-title="大图局部放大器"
                class="magnifier-layer"
                v-show="showMagnifier"
                :style="{
                    width: configs.width + 'px',
                    height: configs.height + 'px',
                    left: configs.width + 20 + 'px',
                }"
                v-if="!vuex_h5"
            >
                <div
                    class="big-box"
                    :style="{
                        width: bigWidth + 'px',
                        height: bigHeight + 'px',
                        left: moveLeft,
                        top: moveTop,
                    }"
                >
                    <div
                        class="big-box-img"
                        :style="{
                            width: bigWidth - 2 + 'px',
                            height: bigHeight - 2 + 'px',
                        }"
                    >
                        <img
                            :src="bigSrc"
                            :style="{
                                maxWidth: bigWidth - 2 + 'px',
                                maxHeight: bigHeight - 2 + 'px',
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'carouselComponent',
    components: {},
    props: {
        // 小图地址
        src: {
            type: String,
        },
        // 大图地址
        bigSrc: {
            type: String,
        },
        // 配置项
        configs: {
            type: Object,
            default() {
                return {
                    width: 760, //放大区域
                    height: 530, //放大区域
                    maskWidth: 160, //遮罩
                    maskHeight: 160, //遮罩
                    maskColor: 'rgba(25,122,255,0.5)', //遮罩样式
                    maskOpacity: 0.6,
                    scale: 3.125, //放大比例
                }
            },
        },
    },

    data() {
        return {
            imgObj: {},
            moveLeft: 0,
            moveTop: 0,
            transformMask: `translate(0px, 0px)`,
            showMagnifier: false,
            showMask: false,
            init: false,
        }
    },
    computed: {
        bigWidth() {
            return this.configs.scale * this.configs.width
        },
        bigHeight() {
            return this.configs.scale * this.configs.height
        },
    },
    methods: {
        handMove(e) {
            // console.log("鼠标移动", e);

            // 动态获取小图的位置（或者监听 scroll ）
            let imgRectNow = this.imgObj.getBoundingClientRect()
            // console.log("元素边界 imgRectNow", imgRectNow);

            let objX = e.clientX - imgRectNow.left
            let objY = e.clientY - imgRectNow.top

            // 计算初始的遮罩左上角的坐标
            let maskX = objX - this.configs.maskWidth / 2
            let maskY = objY - this.configs.maskHeight / 2

            // 判断是否超出界限,并纠正
            maskY = maskY < 0 ? 0 : maskY
            maskX = maskX < 0 ? 0 : maskX
            if (maskY + this.configs.maskHeight >= imgRectNow.height) {
                maskY = imgRectNow.height - this.configs.maskHeight
            }
            if (maskX + this.configs.maskWidth >= imgRectNow.width) {
                maskX = imgRectNow.width - this.configs.maskWidth
            }

            // 遮罩移动
            this.transformMask = `translate(${maskX}px, ${maskY}px)`

            // 背景图移动
            this.moveLeft = -maskX * this.configs.scale + 'px'
            this.moveTop = -maskY * this.configs.scale + 'px'
        },
        handOut() {
            this.showMagnifier = false
            this.showMask = false
        },
        handOver() {
            if (!this.init) {
                this.init = true
                this.imgObj = this.$el.getElementsByClassName('small-box')[0]
            }
            this.showMagnifier = true
            this.showMask = true
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.magnifier {
    background: #eee;
    background: #fff;
    position: relative;

    .magnifier-inner {
        margin: 0 auto;
        position: relative;
        width: 760px;
        height: 530px;
    }
}

// 小图容器
.small-box {
    position: relative;
    // border: 1px solid #eee;
    overflow: hidden;
    cursor: all-scroll;
    width: 760px;
    height: 530px;
    margin: 0 auto;

    .smallPic {
        width: 100%;
        height: 100%;
        // vertical-align: bottom;
        object-fit: cover;
    }

    .magnifier-zoom {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
    }
}

// 弹层容器
.magnifier-layer {
    position: absolute;
    z-index: 100;
    left: 760px;
    top: 0;
    width: 760px;
    height: 530px;
    border: 1px solid #ddd;
    overflow: hidden;
    background: #fff;

    .big-box {
        position: relative;

        .big-box-img {
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                // vertical-align: bottom;
            }
        }
    }
}

@media screen and (max-width: 1024px) {
    .magnifier {
        .magnifier-inner {
            margin: 0 auto;
            position: relative;
            width: 100%;
            height: auto;
        }
    }

    // 小图容器
    .small-box {
        position: relative;
        // border: 1px solid #eee;
        overflow: hidden;
        cursor: all-scroll;
        width: 100%;
        height: auto;
        margin: 0 auto;

        .smallPic {
            width: 100%;
            height: 100%;
            // vertical-align: bottom;
            object-fit: cover;
        }

        .magnifier-zoom {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }
    }

    // 弹层容器
    .magnifier-layer {
        position: absolute;
        z-index: 100;
        left: 760px;
        top: 0;
        width: 760px;
        height: 530px;
        border: 1px solid #ddd;
        overflow: hidden;
        background: #fff;

        .big-box {
            position: relative;

            .big-box-img {
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    // vertical-align: bottom;
                }
            }
        }
    }
}
</style>
